// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContactUs.css */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}

.contactus-container {
  font-family: "Montserrat", sans-serif;
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.6;
}

/* Hero Section */
.contactus-hero {
  position: relative;
  text-align: center;
  margin-bottom: 60px;
}

.contactus-hero-image {
  height: 400px;
  background-size: cover;
  background-position: center;
  border-radius: 15px;
  overflow: hidden;
}

.contactus-hero-overlay {
  position: relative;
  margin: 10px auto 0;
  background: rgba(0, 0, 0, 0.7);
  font-family: "Montserrat", sans-serif;
  padding: 20px;
  border-radius: 15px;
  color: white;
  max-width: 600px;
  text-align: center;
  backdrop-filter: blur(5px);
  animation: fadeIn 1s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.contactus-hero-overlay h1 {
  font-size: 2.5rem;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 10px;
  font-weight: 700;
  text-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.contactus-hero-overlay p {
  font-size: 1.2rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Main Content Section */
.contactus-main {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
}

.contactus-info,
.contactus-form {
  flex: 1 1;
  background-color: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.contactus-info:hover,
.contactus-form:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
}

.contactus-info-item {
  margin-bottom: 25px;
  text-align: center;
}

.contactus-icon {
  font-size: 2rem;
  font-family: "Montserrat", sans-serif;
  color: #007bff;
  margin-bottom: 15px;
}

.contactus-info-item h2 {
  font-size: 1.6rem;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 10px;
  font-weight: 600;
  text-align: center;

}

.contactus-info-item p {
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  color: #555;
  line-height: 1.6;
}

/* Contact Form */
.contactus-form h2 {
  font-size: 2rem;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 25px;
  font-weight: 600;
  text-align: center;
}

.form-group {
  margin-bottom: 20px;
  position: relative;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 15px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  color: #555;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #007bff;
  outline: none;
}

.error {
  color: #ff0000;
  font-size: 0.8rem;
  margin-top: 5px;
  display: block;
}

.submit-button {
  background-color: #007bff;
  color: white;
  padding: 15px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background-color 0.3s ease;
  margin-top: 10px;
  width: 100%;
}

.submit-button:hover {
  background-color: #0056b3;
}

.submit-icon {
  font-size: 1.2rem;
  font-family: "Montserrat", sans-serif;
}

/* Google Maps Section */
.contactus-map {
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
  text-align: center;
}

.contactus-map h2 {
  font-size: 2rem;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 25px;
  font-weight: 600;
}

.contactus-map iframe {
  width: 100%;
  height: 400px;
  border-radius: 15px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

/* Footer */
.contactus-footer {
  text-align: center;
  padding: 20px;
  background-color: #333;
  color: white;
  font-size: 0.9rem;
  font-family: "Montserrat", sans-serif;
  width: 100%;
}

/* Media Queries for Responsiveness */
@media (max-width: 1200px) {
  .contactus-hero-overlay h1 {
    font-size: 2.5rem;
  }

  .contactus-hero-overlay p {
    font-size: 1.1rem;
  }

  .contactus-main {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }

  .contactus-info,
  .contactus-form {
    width: 100%;
    max-width: 800px;
  }
}

@media (max-width: 768px) {
  .contactus-hero-image {
    height: 300px;
  }

  .contactus-hero-overlay {
    padding: 20px;
    margin: -80px auto 0;
  }

  .contactus-hero-overlay h1 {
    font-size: 2rem;
  }

  .contactus-hero-overlay p {
    font-size: 1rem;
  }

  .contactus-info-item h2 {
    font-size: 1.4rem;
  }

  .contactus-info-item p {
    font-size: 0.9rem;
  }

  .contactus-form h2 {
    font-size: 1.8rem;
  }

  .contactus-map h2 {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .contactus-hero-image {
    height: 250px;
  }

  .contactus-hero-overlay {
    padding: 15px;
    margin: -60px auto 0;
  }

  .contactus-hero-overlay h1 {
    font-size: 1.8rem;
  }

  .contactus-hero-overlay p {
    font-size: 0.9rem;
  }

  .contactus-info-item h2 {
    font-size: 1.2rem;
  }

  .contactus-info-item p {
    font-size: 0.8rem;
  }

  .contactus-form h2 {
    font-size: 1.6rem;
  }

  .contactus-map h2 {
    font-size: 1.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactUs.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAGlB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,SAAO;EACP,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;;EAEE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,WAAW;EACX,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ContactUs.css */\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n.contactus-container {\n  font-family: \"Montserrat\", sans-serif;\n  background-color: #f9f9f9;\n  color: #333;\n  line-height: 1.6;\n}\n\n/* Hero Section */\n.contactus-hero {\n  position: relative;\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.contactus-hero-image {\n  height: 400px;\n  background-size: cover;\n  background-position: center;\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n.contactus-hero-overlay {\n  position: relative;\n  margin: 10px auto 0;\n  background: rgba(0, 0, 0, 0.7);\n  font-family: \"Montserrat\", sans-serif;\n  padding: 20px;\n  border-radius: 15px;\n  color: white;\n  max-width: 600px;\n  text-align: center;\n  backdrop-filter: blur(5px);\n  animation: fadeIn 1s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.contactus-hero-overlay h1 {\n  font-size: 2.5rem;\n  font-family: \"Montserrat\", sans-serif;\n  margin-bottom: 10px;\n  font-weight: 700;\n  text-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.contactus-hero-overlay p {\n  font-size: 1.2rem;\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 400;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n/* Main Content Section */\n.contactus-main {\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n  max-width: 1200px;\n  margin: 40px auto;\n  padding: 0 20px;\n}\n\n.contactus-info,\n.contactus-form {\n  flex: 1;\n  background-color: white;\n  padding: 30px;\n  border-radius: 15px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.contactus-info:hover,\n.contactus-form:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n}\n\n.contactus-info-item {\n  margin-bottom: 25px;\n  text-align: center;\n}\n\n.contactus-icon {\n  font-size: 2rem;\n  font-family: \"Montserrat\", sans-serif;\n  color: #007bff;\n  margin-bottom: 15px;\n}\n\n.contactus-info-item h2 {\n  font-size: 1.6rem;\n  font-family: \"Montserrat\", sans-serif;\n  margin-bottom: 10px;\n  font-weight: 600;\n  text-align: center;\n\n}\n\n.contactus-info-item p {\n  font-size: 1rem;\n  font-family: \"Montserrat\", sans-serif;\n  color: #555;\n  line-height: 1.6;\n}\n\n/* Contact Form */\n.contactus-form h2 {\n  font-size: 2rem;\n  font-family: \"Montserrat\", sans-serif;\n  margin-bottom: 25px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 15px;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: \"Montserrat\", sans-serif;\n  color: #555;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.error {\n  color: #ff0000;\n  font-size: 0.8rem;\n  margin-top: 5px;\n  display: block;\n}\n\n.submit-button {\n  background-color: #007bff;\n  color: white;\n  padding: 15px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: \"Montserrat\", sans-serif;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: background-color 0.3s ease;\n  margin-top: 10px;\n  width: 100%;\n}\n\n.submit-button:hover {\n  background-color: #0056b3;\n}\n\n.submit-icon {\n  font-size: 1.2rem;\n  font-family: \"Montserrat\", sans-serif;\n}\n\n/* Google Maps Section */\n.contactus-map {\n  max-width: 1200px;\n  margin: 40px auto;\n  padding: 0 20px;\n  text-align: center;\n}\n\n.contactus-map h2 {\n  font-size: 2rem;\n  font-family: \"Montserrat\", sans-serif;\n  margin-bottom: 25px;\n  font-weight: 600;\n}\n\n.contactus-map iframe {\n  width: 100%;\n  height: 400px;\n  border-radius: 15px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Footer */\n.contactus-footer {\n  text-align: center;\n  padding: 20px;\n  background-color: #333;\n  color: white;\n  font-size: 0.9rem;\n  font-family: \"Montserrat\", sans-serif;\n  width: 100%;\n}\n\n/* Media Queries for Responsiveness */\n@media (max-width: 1200px) {\n  .contactus-hero-overlay h1 {\n    font-size: 2.5rem;\n  }\n\n  .contactus-hero-overlay p {\n    font-size: 1.1rem;\n  }\n\n  .contactus-main {\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n  }\n\n  .contactus-info,\n  .contactus-form {\n    width: 100%;\n    max-width: 800px;\n  }\n}\n\n@media (max-width: 768px) {\n  .contactus-hero-image {\n    height: 300px;\n  }\n\n  .contactus-hero-overlay {\n    padding: 20px;\n    margin: -80px auto 0;\n  }\n\n  .contactus-hero-overlay h1 {\n    font-size: 2rem;\n  }\n\n  .contactus-hero-overlay p {\n    font-size: 1rem;\n  }\n\n  .contactus-info-item h2 {\n    font-size: 1.4rem;\n  }\n\n  .contactus-info-item p {\n    font-size: 0.9rem;\n  }\n\n  .contactus-form h2 {\n    font-size: 1.8rem;\n  }\n\n  .contactus-map h2 {\n    font-size: 1.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .contactus-hero-image {\n    height: 250px;\n  }\n\n  .contactus-hero-overlay {\n    padding: 15px;\n    margin: -60px auto 0;\n  }\n\n  .contactus-hero-overlay h1 {\n    font-size: 1.8rem;\n  }\n\n  .contactus-hero-overlay p {\n    font-size: 0.9rem;\n  }\n\n  .contactus-info-item h2 {\n    font-size: 1.2rem;\n  }\n\n  .contactus-info-item p {\n    font-size: 0.8rem;\n  }\n\n  .contactus-form h2 {\n    font-size: 1.6rem;\n  }\n\n  .contactus-map h2 {\n    font-size: 1.6rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
